import { ReactElement } from 'react';
import { Heading } from '@appsumo/dorado-react';

export default function DealHeader({
  titleList,
}: {
  titleList: string[];
}): ReactElement {
  return (
    <>
      {titleList.map((title: string) => (
        <Heading.H5 key={title} className="last:justify-self-end">
          {title}
        </Heading.H5>
      ))}
    </>
  );
}

export { DealHeader };
